import { Component, Input, OnInit } from '@angular/core';

type MapOverlayPosition = 'left' | 'right';

@Component({
  selector: 'app-map-overlay',
  templateUrl: './map-overlay.component.html',
  styleUrls: ['./map-overlay.component.scss']
})
export class MapOverlayComponent implements OnInit {

  @Input()
  position: MapOverlayPosition = 'left';

  constructor() {
  }

  ngOnInit() {
  }

}
